var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qk-video"},[_c('video',{attrs:{"src":_vm.videoSrc,"poster":_vm.videoPoster,"preload":_vm.preload,"playsinline":_vm.playsinline,"controls":_vm.controls,"controlslist":_vm.controlslist,"title":_vm.title}})])
}
var staticRenderFns = []

export { render, staticRenderFns }